import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, breakpoint, size } from '@twisto/styles'

import type { Size, Variant } from '../../banner'

export const container = css`
  display: grid;
  justify-items: center;
  align-items: center;
  grid-area: icon;
  align-self: center;
`

export const containerSize = css`
  width: 36px;
  height: 36px;
  border-radius: ${borderRadius.circle};

  ${breakpoint.up('sm')} {
    width: ${size[48]};
    height: ${size[48]};
  }
`

export const containerOffset: Record<Size, SerializedStyles> = {
  small: css`
    margin-right: ${size[8]};

    ${breakpoint.up('sm')} {
      margin-right: ${size[12]};
    }
  `,
  medium: css`
    margin-right: ${size[8]};

    ${breakpoint.up('sm')} {
      margin-right: ${size[16]};
    }
  `,
}

export const containerBackground: Record<
  Variant,
  (theme: Theme) => SerializedStyles
> = {
  primary: (theme) => css`
    background-color: ${theme.palette.brand[100]};
  `,
  secondary: (theme) => css`
    background-color: ${theme.palette.neutral[100]};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning[100]};
  `,
  error: (theme) => css`
    background-color: ${theme.palette.error[100]};
  `,
}

export const iconColor: Record<Variant, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    color: ${theme.palette.brand[500]};
  `,
  secondary: (theme) => css`
    color: ${theme.palette.neutral[700]};
  `,
  warning: (theme) => css`
    color: ${theme.palette.warning[500]};
  `,
  error: (theme) => css`
    color: ${theme.palette.error[500]};
  `,
}
export const iconSize: Record<Size, SerializedStyles> = {
  small: css`
    width: ${size[24]};
    height: ${size[24]};
  `,
  medium: css`
    width: ${size[24]};
    height: ${size[24]};

    ${breakpoint.up('sm')} {
      width: ${size[32]};
      height: ${size[32]};
    }
  `,
}
